export default function PhoneIcon({ className }: { className?: string }) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5179 9.15529C12.1856 8.82314 11.7294 8.66372 11.2598 8.71244C10.7902 8.76116 10.3783 9.018 10.1214 9.41657L9.98845 9.62028C9.77582 9.95685 9.3417 10.0897 8.95631 9.93913C7.57862 9.39886 6.62614 8.42906 6.05473 6.96759C5.9174 6.61774 6.05916 6.21032 6.39582 5.99333L6.58187 5.87376C6.97612 5.62134 7.23307 5.20949 7.28622 4.74007C7.33495 4.27065 7.17548 3.81453 6.83882 3.47796L5.81552 2.45498C5.27952 1.91914 4.44227 1.84828 3.82216 2.2867L2.94949 2.9111C2.11668 3.50452 1.78444 4.57621 2.14326 5.51944C3.67152 9.54049 6.47557 12.3437 10.4847 13.8583C10.7372 13.9513 10.9985 14 11.2555 14C11.9642 14 12.6509 13.659 13.085 13.0523L13.7096 12.1755C14.1525 11.5555 14.0817 10.7185 13.5457 10.1827L12.5179 9.15529Z'
        fill='currentColor'
      />
    </svg>
  );
}
